import React from 'react'

import { HouseCorporateEveningGlobalCapacityFields } from './capacity-fields/HouseCorporateEveningGlobalCapacityFields'
import { HouseCorporateEveningGlobalHoursFields } from './hours-fields/HouseCorporateEveningGlobalHoursFields'
import { HouseCorporateEveningGlobalVatField } from './vat-field/HouseCorporateEveningGlobalVatField'
import { HouseCorporateEveningGlobalFieldProps } from '../form-container/HouseCorporateEveningGlobalFormContainer'
import { Divider } from '../../../../../../../atoms/divider/Divider'

export const HouseCorporateEveningGlobalOptionsFields = ({
  currencyArea,
  ...fieldProps
}: HouseCorporateEveningGlobalFieldProps) => {
  return (
    <>
      <Divider />

      <HouseCorporateEveningGlobalCapacityFields {...fieldProps} />

      <Divider />

      <HouseCorporateEveningGlobalHoursFields {...fieldProps} />

      <Divider />

      <HouseCorporateEveningGlobalVatField
        {...fieldProps}
        currencyArea={currencyArea}
      />
    </>
  )
}
